'use client'

import { useTranslations } from 'next-intl'

import WorldGenres from '@/app/[locale]/[roomId]/components/WorldGenres'
import DeviceIcons from '@/components/DeviceIcons'
import { Separator } from '@/components/ui/separator'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'

function WorldInfoDetails() {
  const t = useTranslations()

  const { roomData } = useCheckEnterRoomContext()
  const preferredDevice = roomData.preferred_devices || []
  const descriptionPlaintext = roomData.description_plaintext

  return (
    <div className="bg-vive-surface-normal flex flex-col gap-4 rounded-2xl px-6 py-4">
      <div className="flex w-full items-start justify-between md:items-center">
        {/* TODO: Add release date */}
        {/* <div className="flex flex-col gap-0.5 md:flex-row md:gap-4">
          <span className="subheader-3 text-vive-primary-30">Release Date</span>
          <span className="body-2 text-white">October 15, 2024</span>
        </div> */}

        <div className="body-4 flex items-center gap-2 text-[14px]">
          {t('world-info.device-available')}
          <DeviceIcons deviceType={preferredDevice} />
        </div>
      </div>

      <WorldGenres />

      {descriptionPlaintext && (
        <>
          <Separator className="bg-vive-primary-60 w-full" />
          <p className="body-1 w-full whitespace-pre-wrap text-white">{descriptionPlaintext}</p>
        </>
      )}
    </div>
  )
}

export default WorldInfoDetails
